import { AgeRange } from '../interfaces/AgeRange';

export const formatAgeRangeLabel = ({ from, to }: AgeRange): string => {
  return to === null ? `${from}+` : `${from}-${to}`;
};
